import { Component, ViewEncapsulation, Inject } from "@angular/core";

import { Routing } from "../../shared/route/routeDecorator";
import { AppStoreSubscriptionManager, ApplicationLifeCycleService, ApiMessageProvider, AppActionCreator, RouteNames, IHttpDataInfo, BroadcastChannelService, BroadcastChannelMessageType } from "../shared/providers";
import { PageComponent } from "../shared";
import { GlobalDataStore } from "../shared/providers/globalData";
import { AccountDataStore } from "../shared/providers/accountData";
import { NotificationService, NotificationInfo, NotificationType } from "../../shared/components";
// Customization (modified - Assortment, Product added)
import { CacheReloadMessage, Assortment, Product, RefObject } from "../shared/models";
// End customization
import { PageStore } from "../shared/providers/page";

// Customization
import { ViewChild, ElementRef } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import * as Immutable from "immutable";
import { PriceListCategory } from "../shared/models";
import { MessageBoxComponent, MessageBoxConfig, InputViewModel } from "../../shared/components"
import { HttpService } from "../../shared/providers";
import { ProductDataStore } from "../shared/providers/productData";
import { ModelLabelService } from "../shared/providers/modelLabelService";
import { HttpInterceptService } from "../shared/providers/httpInterceptService";
import { HttpLifeCycleService } from "../shared/providers/httpLifeCycleService";
import { ExceptionHandler } from "../shared/providers/exceptionHandler"
import { ModelFactory } from '../shared/providers/modelFactory';
import { ScheduleChangePopupComponent, ScheduleChangeData } from "./popups/scheduleChange/scheduleChangePopupComponent";
import { ScheduledChangesListComponent, ScheduledChangesListItem } from "./components";
import { SignalRService } from "../shared/providers/pushMessage/signalRService";
import { HttpRequestTrackerService } from "../shared/providers/httpRequestTrackerService";
// End customization

@Routing({ path: 'settings' })
@Routing({ path: '**' })
@Component({
  encapsulation: ViewEncapsulation.None,
  templateUrl: './settingsComponent.html',
  providers: [AppStoreSubscriptionManager]
})
export class SettingsComponent extends PageComponent {

  public databaseConnectionInfo: string = "";

  public showAdminSection: boolean = false;

  private enableDefaultLifeCycleUpdate = true;
  // Customization - define view data for Product selection dropdown, controller url

  public showSimulateBomChanges: boolean = false;
  public showSimulatePriceChanges: boolean = false;
  public showSimulateCompStringChanges: boolean = false;
  public showSimulateAttributeChanges: boolean = false;
  public showSimulateCatProdInfoChanges: boolean = false;
  public showSimulateJeevesProdInfoChanges: boolean = false;
  public showPerformBomChanges: boolean = false;
  public showPerformPriceChanges: boolean = false;
  public showPerformCompStringChanges: boolean = false;
  public showPerformAttributeChanges: boolean = false;
  public showPerformCatProdInfoChanges: boolean = false;
  public showPerformJeevesProdInfoChanges: boolean = false;

  bomSimulateUrl = "fagerhult/bomchangemanagement/simulate";
  bomPerformChangesUrl = "fagerhult/bomchangemanagement/performchanges";
  bomSchedulePerformChangesUrl = "fagerhult/bomchangemanagement/scheduleperformchanges";
  bomRemoveScheduledPerformChangesUrl = "fagerhult/bomchangemanagement/removescheduledperformchanges";

  priceSimulateUrl = "fagerhult/pricechangemanagement/simulate";
  pricePerformChangesUrl = "fagerhult/pricechangemanagement/performchanges";
  priceSchedulePerformChangesUrl = "fagerhult/pricechangemanagement/scheduleperformchanges";
  priceRemoveScheduledPerformChangesUrl = "fagerhult/pricechangemanagement/removescheduledperformchanges";

  compStringSimulateUrl = "fagerhult/compstringchangemanagement/simulate";
  compStringPerformChangesUrl = "fagerhult/compstringchangemanagement/performchanges";

  attributeSimulateUrl = "fagerhult/attributechangemanagement/simulate";
  attributePerformChangesUrl = "fagerhult/attributechangemanagement/performchanges";

  catprodinfoSimulateUrl = "fagerhult/catalogueprodinfochangemanagement/simulate";
  catprodinfoPerformChangesUrl = "fagerhult/catalogueprodinfochangemanagement/performchanges";

  jeevesprodinfoSimulateUrl = "fagerhult/jeevesprodinfochangemanagement/simulate";
  jeevesprodinfoPerformChangesUrl = "fagerhult/jeevesprodinfochangemanagement/performchanges";

  productBomView: InputViewModel;
  productPriceView: InputViewModel;
  productCompStringView: InputViewModel;
  productAttributeView: InputViewModel;
  productCatProdInfoView: InputViewModel;
  productJeevesProdInfoView: InputViewModel;
  productsView: InputViewModel[] = [];

  priceListCategoryView: InputViewModel;
  priceListCategoriesView: InputViewModel[] = [];

  @ViewChild("downloadLink")
  protected fileDownloadER: ElementRef;

  @ViewChild(MessageBoxComponent)
  public confirmPerformChangesMessageBox: MessageBoxComponent;

  @ViewChild(ScheduleChangePopupComponent)
  public confirmScheduleChangePopup: ScheduleChangePopupComponent;

  @ViewChild('bomScheduledChangesList')
  public bomScheduledChangesList: ScheduledChangesListComponent;

  @ViewChild('priceScheduledChangesList')
  public priceScheduledChangesList: ScheduledChangesListComponent;

  protected httpInterceptService: HttpInterceptService;

  datePickerConfig = {
    firstDayOfWeek: 'su',
    monthFormat: 'MMM, YYYY',
    disableKeypress: false,
    allowMultiSelect: false,
    closeOnSelect: undefined,
    closeOnSelectDelay: 100,
    openOnFocus: true,
    openOnClick: true,
    onOpenDelay: 0,
    closeOnEnter: true,
    weekDayFormat: 'ddd',
    appendTo: document.body,
    showNearMonthDays: true,
    showWeekNumbers: true,
    enableMonthSelector: true,
    yearFormat: 'YYYY',
    showGoToCurrent: true,
    dayBtnFormat: 'DD',
    monthBtnFormat: 'MMM',
    hours12Format: 'hh',
    hours24Format: 'HH',
    meridiemFormat: 'A',
    minutesFormat: 'mm',
    minutesInterval: 1,
    secondsFormat: 'ss',
    secondsInterval: 1,
    showSeconds: false,
    showTwentyFourHours: false,
    timeSeparator: ':',
    multipleYearsNavigateBy: 10,
    showMultipleYearsNavigation: false,
    //locale: moment.locale(),
    hideInputContainer: false,
    //returnedValueType: ECalendarValue.String,
    unSelectOnClick: true,
    hideOnOutsideClick: true,
    numOfMonthRows: 3
  };
   // End customization

  constructor(
    public appActionCreator: AppActionCreator,
    public appLifeCycleService: ApplicationLifeCycleService,
    public appStoreSubscriptionManager: AppStoreSubscriptionManager,
    public globalDataStore: GlobalDataStore,
    public accountStore: AccountDataStore,
    public notificationService: NotificationService,
    @Inject(ApiMessageProvider) public apiMessageProvider: ApiMessageProvider,
    public pageStore: PageStore,
    @Inject(BroadcastChannelService) public broadcastChannelService: BroadcastChannelService,
    // Customization
    protected productDataStore: ProductDataStore,
    protected modelLabelService: ModelLabelService,
    protected httpService: HttpService,
    protected httpClient: HttpClient,
    modelFactory: ModelFactory,
    public httpLifeCycle: HttpLifeCycleService,
    exceptionHandler: ExceptionHandler,
    @Inject(SignalRService) public signalRService: SignalRService,
    @Inject(AccountDataStore) public accountDataStore: AccountDataStore,
    @Inject(HttpRequestTrackerService) public httpRequestTrackerService: HttpRequestTrackerService,
    // End customization
  ) {
    super();
    // Customization
    this.httpInterceptService = new HttpInterceptService(accountDataStore, exceptionHandler, httpLifeCycle, signalRService, modelFactory, httpRequestTrackerService);
    // End Customization
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageStore.updateActiveRoute(RouteNames.Settings);

    this.setInfo();
    // Customization
    this.setProductSelectionInfo();
    // End customization

    this.apiMessageProvider.onMessages<CacheReloadMessage>(CacheReloadMessage.name, {
      next: (messages) => {
        let cacheReloadMessage = messages.first();
        if (cacheReloadMessage.success) {

          this.appLifeCycleService.cacheReloaded(() => {
            this.notificationService.notify(<NotificationInfo>{
              title: this.strings.Success,
              message: this.strings.ReloadCaches_Message,
              type: NotificationType.Success,
              selfClose: true
            });

            this.broadcastChannelService.send(BroadcastChannelMessageType.ReloadCache);
            this.setInfo();
            this.enableDefaultLifeCycleUpdate = true;

            // Customization
            this.setProductSelectionInfo();
            // End customization

            this.unblockUI();
          });
        }
        else {
          // Handle server errors in message
          this.notificationService.notify(<NotificationInfo>{
            title: this.strings.Error,
            message: cacheReloadMessage.messages.join(". "), // TODO handle in better way
            type: NotificationType.Error,
            selfClose: true
          });

          this.enableDefaultLifeCycleUpdate = true;
          this.unblockUI();
        }
      }, listenNewEventsOnly: true
    }).unsubscribeOn(this.unsubscribeSubject);
  }

  public reloadCaches() {
    this.reload(false);
  }

  public reloadUserCaches() {
    this.reload(true);
  }

  public reload(userDataOnly: boolean) {
    this.blockUI();
    this.enableDefaultLifeCycleUpdate = false;
    this.appActionCreator.dispatchReloadCaches(userDataOnly);
  }

  // Customization

  setProductSelectionInfo() {

    this.productsView = [];
    this.priceListCategoriesView = [];

    this.productBomView = new InputViewModel("");
    this.productBomView.title = "Product";
    this.productBomView.width = "200px";

    this.productCompStringView = new InputViewModel("");
    this.productCompStringView.title = "Product";
    this.productCompStringView.width = "200px";

    this.productPriceView = new InputViewModel("");
    this.productPriceView.title = "Product";
    this.productPriceView.width = "200px";

    this.priceListCategoryView = new InputViewModel("");
    this.priceListCategoryView.title = "Price list category";
    this.priceListCategoryView.width = "200px";

    this.productAttributeView = new InputViewModel("");
    this.productAttributeView.title = "Product";
    this.productAttributeView.width = "200px";

    this.productCatProdInfoView = new InputViewModel("");
    this.productCatProdInfoView.title = "Product";
    this.productCatProdInfoView.width = "200px";

    this.productJeevesProdInfoView = new InputViewModel("");
    this.productJeevesProdInfoView.title = "Product";
    this.productJeevesProdInfoView.width = "200px";

    this.productDataStore.getRootAssortments().subscribe(storeResponse => {

      storeResponse.data.forEach(assortment => {

        let products: Product[] = [];
        if (assortment.className == Product.name)
          products.push(assortment as Product);
        else
          products.push(...this.getChildProducts(assortment));

        products.forEach(product => {
          let viewModel = new InputViewModel(this.modelLabelService.getLabel(product));
          viewModel.id = product.longId.toString();
          this.productsView.push(viewModel);          
        });
      });

      this.productsView.sort((a, b) => a.title.localeCompare(b.title));

      if (this.productsView.length > 0) {
        this.productBomView.formattedValue = this.productsView[0].title;
        this.productBomView.value = this.productsView[0].id;

        this.productCompStringView.formattedValue = this.productsView[0].title;
        this.productCompStringView.value = this.productsView[0].id;

        this.productPriceView.formattedValue = this.productsView[0].title;
        this.productPriceView.value = this.productsView[0].id;

        this.productAttributeView.formattedValue = this.productsView[0].title;
        this.productAttributeView.value = this.productsView[0].id;

        this.productCatProdInfoView.formattedValue = this.productsView[0].title;
        this.productCatProdInfoView.value = this.productsView[0].id;

        this.productJeevesProdInfoView.formattedValue = this.productsView[0].title;
        this.productJeevesProdInfoView.value = this.productsView[0].id;

        this.onProductSelectionChange();
      }
    });

  }

  getChildProducts(assortment: Assortment) {

    let children: Product[] = [];

    if (assortment.children && assortment.children.size > 0) {
      assortment.children.forEach(id => {
        let childAssortment = this.productDataStore.getEntity<Assortment>(id);
        if (childAssortment) {
          if (childAssortment.className == Product.name)
            children.push(childAssortment as Product);
          else
            children.push(...this.getChildProducts(childAssortment));
        }
      });
    }

    return children;
  }

  onProductSelectionChange() {

    this.priceListCategoriesView = [];
    this.priceListCategoryView = new InputViewModel("");
    this.priceListCategoryView.title = "Price list category";
    this.priceListCategoryView.width = "200px";

    this.productDataStore.getProduct(+this.productPriceView.value, (product => {

      if (!product)
        return;

      let productPlcIds: Immutable.List<number> = product.propertyMap.get("effectivePriceListCategories");
      let productPlcs: PriceListCategory[] = [];

      this.globalDataStore.getEntities<PriceListCategory>(PriceListCategory.name).subscribe(storeResponse => {

        const viewModelAllIct = new InputViewModel("All ICT Price Lists");
        viewModelAllIct.id = "-1";
        this.priceListCategoriesView.push(viewModelAllIct);

        let allPlcObjects: Immutable.Map<number, PriceListCategory> = storeResponse.data;

        productPlcIds.forEach(plcId => {
          let plc = allPlcObjects.get(plcId);
          if (plc)
            productPlcs.push(plc);
        });

        for (let plc of productPlcs) {
          let viewModel = new InputViewModel(plc.title);
          viewModel.id = plc.longId.toString();
          this.priceListCategoriesView.push(viewModel);
        }

        if (this.priceListCategoriesView.length > 0) {
          this.priceListCategoryView.formattedValue = this.priceListCategoriesView[0].title;
          this.priceListCategoryView.value = this.priceListCategoriesView[0].id;
        }
      });

    }));
  }

  onSimulateChangesClick($event: string) {

    if ($event == "bom") {
      let url = `${this.httpService.createUrl(this.bomSimulateUrl)}&productid=${this.productBomView.value}`;
      this.downloadFile(url, "BOM Simulation", this.productBomView.value);
    }
    else if($event == "price")
    {
      let url = `${this.httpService.createUrl(this.priceSimulateUrl)}&productid=${this.productPriceView.value}&pricelistcategoryid=${this.priceListCategoryView.value}`;
      this.downloadFile(url, "Price Simulation", this.productPriceView.value);
    }
    else if ($event == "compstring") {
      let url = `${this.httpService.createUrl(this.compStringSimulateUrl)}&productid=${this.productCompStringView.value}`;
      this.downloadFile(url, "Comparison String Simulation", this.productCompStringView.value);
    }
    else if ($event == "attribute") {
      let url = `${this.httpService.createUrl(this.attributeSimulateUrl)}&productid=${this.productAttributeView.value}`;
      this.downloadFile(url, "Attribute Simulation", this.productAttributeView.value);
    }
    else if ($event == "catprodinfo") {
      let url = `${this.httpService.createUrl(this.catprodinfoSimulateUrl)}&productid=${this.productCatProdInfoView.value}`;
      this.downloadFile(url, "Catalogue Product Info Simulation", this.productCatProdInfoView.value);
    }
    else if ($event == "jeevesprodinfo") {
      let url = `${this.httpService.createUrl(this.jeevesprodinfoSimulateUrl)}&productid=${this.productJeevesProdInfoView.value}`;
      this.downloadFile(url, "Jeeves Product Info Simulation", this.productJeevesProdInfoView.value);
    }
  }

  onConfirmPerformChangesClick($event: string) {

    let info: MessageBoxConfig<string> = new MessageBoxConfig<string>();
    info.icon = "warning";

    if ($event == "bom") {
      info.headerText = `Have you reloaded the cache and want that item/BOM changes for "${this.productBomView.formattedValue}" should be implemented in Combinum and in the ERP system?`;
      info.tag = "bom";
    }
    else if ($event == "price")
    {
      info.headerText = `Have you reloaded the cache and want that price changes for "${this.productPriceView.formattedValue}" should be implemented in Combinum and in the ERP system?`;
      info.tag = "price";
    }
    else if ($event == "compstring") {
      info.headerText = `Have you reloaded the cache and want that comparison string changes for "${this.productCompStringView.formattedValue}" should be implemented in Combinum?`;
      info.tag = "compstring";
    }
    else if ($event == "attribute") {
      info.headerText = `Have you reloaded the cache and want that attribute changes for "${this.productAttributeView.formattedValue}" should be implemented in Combinum?`;
      info.tag = "attribute";
    }
    else if ($event == "catprodinfo") {
      info.headerText = `Have you reloaded the cache and want that catalogue product info changes for "${this.productCatProdInfoView.formattedValue}" should be sent to the staging table?`;
      info.tag = "catprodinfo";
    }
    else if ($event == "jeevesprodinfo") {
      info.headerText = `Have you reloaded the cache and want that Jeeves product info changes for "${this.productJeevesProdInfoView.formattedValue}" should be sent to the staging table?`;
      info.tag = "jeevesprodinfo";
    }

    this.confirmPerformChangesMessageBox.show(info);
  }

  onPerformChangesClick($event) {

    if ($event == "bom") {
      let url = `${this.httpService.createUrl(this.bomPerformChangesUrl)}&productid=${this.productBomView.value}`;
      this.downloadFile(url, "BOM Changes", this.productBomView.formattedValue);
    }
    else if ($event == "price")
    {
      let url = `${this.httpService.createUrl(this.pricePerformChangesUrl)}&productid=${this.productPriceView.value}&pricelistcategoryid=${this.priceListCategoryView.value}`;
      this.downloadFile(url, "Price Changes", this.productPriceView.formattedValue);
    }
    else if ($event == "compstring") {
      let url = `${this.httpService.createUrl(this.compStringPerformChangesUrl)}&productid=${this.productCompStringView.value}`;
      this.downloadFile(url, "Comparison Strings Changes", this.productCompStringView.formattedValue);
    }
    else if ($event == "attribute") {
      let url = `${this.httpService.createUrl(this.attributePerformChangesUrl)}&productid=${this.productAttributeView.value}`;
      this.downloadFile(url, "Attribute Changes", this.productAttributeView.formattedValue);
    }
    else if ($event == "catprodinfo") {
      let url = `${this.httpService.createUrl(this.catprodinfoPerformChangesUrl)}&productid=${this.productCatProdInfoView.value}`;
      this.downloadFile(url, "Catalogue Product Info Changes", this.productCatProdInfoView.formattedValue);
    }
    else if ($event == "jeevesprodinfo") {
      let url = `${this.httpService.createUrl(this.jeevesprodinfoPerformChangesUrl)}&productid=${this.productJeevesProdInfoView.value}`;
      this.downloadFile(url, "Jeeves Product Info Changes", this.productJeevesProdInfoView.formattedValue);
    }
  }
    
  // This method should be moved to main in http service for downloading files
  downloadFile(url: string, filePrefix: string, productTitle: string) {
    
    let fileName = `${filePrefix} - ${productTitle.replace(/[^a-z0-9]/gi, '_')}.xlsx`;
        
    let fileDownloadSubscription = this.httpClient.request("get", url, { observe: 'response', responseType: 'arraybuffer' })
      .subscribe(response => {

        if (response.headers.get("Content-Type") == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {

          let blobData = new Blob([response.body]);
          if (blobData) {

            // Extract the filename from the server response headers
            let contentDisposition = response.headers.get('Content-Disposition');
            if (contentDisposition) {
              let matches = /filename="(.*?)"/g.exec(contentDisposition);
              if (matches && matches.length > 1) fileName = matches[1];
            }

            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blobData, fileName);
            }
            else {
              this.fileDownloadER.nativeElement.href = URL.createObjectURL(blobData);
              this.fileDownloadER.nativeElement.download = fileName;
              // start download
              this.fileDownloadER.nativeElement.click();
            }
          }
        }
        else {
          try {
            // Convert the response to JSON
            let jsonString = String.fromCharCode.apply(null, new Uint8Array(response.body));
            let httpErrorResponse = new HttpErrorResponse({ error: JSON.parse(jsonString), headers: response.headers, status: response.status, statusText: response.statusText, url: response.url });
            this.httpInterceptService.handleApiException(httpErrorResponse);
          } catch (ex) { }
        }

        fileDownloadSubscription.unsubscribe();
      });
  }

  onConfirmScheduleChangeClick($event) {
    let user = this.accountStore.getUser();
    let scheduleChangeData: ScheduleChangeData = { type: $event, user: user.username };

    if (scheduleChangeData.type == "bom" && this.productBomView.value == this.productsView[0].id)
      return;
    else if (scheduleChangeData.type == "price" && this.productPriceView.value == this.productsView[0].id)
      return;

    if (scheduleChangeData.type == "bom") {
      scheduleChangeData.product = this.productBomView.formattedValue;
      scheduleChangeData.productId = this.productBomView.value;
    }
    else if (scheduleChangeData.type == "price") {
      scheduleChangeData.product = this.productPriceView.formattedValue;
      scheduleChangeData.productId = this.productPriceView.value;
      scheduleChangeData.priceListCategory = this.priceListCategoryView.formattedValue;
      scheduleChangeData.priceListCategoryId = this.priceListCategoryView.value;
    }

    this.confirmScheduleChangePopup.open(scheduleChangeData);
  }

  onPerformScheduleChangeClick($event) {
    let scheduleChangeData: ScheduleChangeData = $event;

    if (scheduleChangeData.type == "bom") {
      let url = `${this.httpService.createUrl(this.bomSchedulePerformChangesUrl)}&productid=${scheduleChangeData.productId}&date=${scheduleChangeData.date}`;
      this.addSchedulePerformChange(url, scheduleChangeData);
    }
    else if (scheduleChangeData.type == "price") {
      let url = `${this.httpService.createUrl(this.priceSchedulePerformChangesUrl)}&productid=${scheduleChangeData.productId}&pricelistcategoryid=${scheduleChangeData.priceListCategoryId}&date=${scheduleChangeData.date}`;
      this.addSchedulePerformChange(url, scheduleChangeData);
    }
  }

  onRemoveScheduledPerformChanges($event) {
    if (!$event)
      return;

    if ($event.type == "bom") {
      let url = `${this.httpService.createUrl(this.bomRemoveScheduledPerformChangesUrl)}&cusscheduledperformchangesid=${$event.id}`;
      this.removeScheduledPerformChanges(url, $event.type);
    }
    else if ($event.type == "price") {
      let url = `${this.httpService.createUrl(this.priceRemoveScheduledPerformChangesUrl)}&cusscheduledperformchangesid=${$event.id}`;
      this.removeScheduledPerformChanges(url, $event.type);
    }
  }

  addSchedulePerformChange(url: string, scheduleChangeData: ScheduleChangeData) {
    if (!url || !scheduleChangeData)
      return;
      
    let addSubscription = this.httpClient.request("get", url, { observe: 'response' }).subscribe(response => {

      if (response.body) {

        let id = response.body.toString();

        if (scheduleChangeData.type == 'bom') {
          let listItem: ScheduledChangesListItem = {
            product: scheduleChangeData.product,
            date: scheduleChangeData.date,
            id: id,
            user: scheduleChangeData.user
          };

          this.bomScheduledChangesList.addListItem(listItem, true);
        }
        else if (scheduleChangeData.type == 'price') {
          let listItem: ScheduledChangesListItem = {
            product: scheduleChangeData.product,
            priceListCategory: scheduleChangeData.priceListCategory,
            date: scheduleChangeData.date,
            id: id,
            user: scheduleChangeData.user
          };

          this.priceScheduledChangesList.addListItem(listItem, true);
        }
        
      }

      addSubscription.unsubscribe();
    });
  }

  removeScheduledPerformChanges(url: string, type: string) {
    if (!url || !type)
      return;

    let removeSubscription = this.httpClient.request("get", url, { observe: 'response' }).subscribe(response => {

      if (response.body) {
        if (type == 'bom')
          this.bomScheduledChangesList.removeListItem(response.body.toString());
        else if (type == 'price')
          this.priceScheduledChangesList.removeListItem(response.body.toString());
      }

      removeSubscription.unsubscribe();
    });
  }

  // End customization

  setInfo() {
    let webSettings = this.globalDataStore.getGlobalData().webSettings;
    this.databaseConnectionInfo = webSettings.databaseConnectionInfo;

    let user = this.accountStore.getUser();

    // Customization
    this.showSimulateBomChanges = user.systemAuthorization.propertyMap.get("canSimulateBOMChanges");
    this.showSimulatePriceChanges = user.systemAuthorization.propertyMap.get("canSimulatePriceChanges");
    this.showSimulateCompStringChanges = user.systemAuthorization.propertyMap.get("canSimulateCompStringChanges");
    this.showSimulateAttributeChanges = user.systemAuthorization.propertyMap.get("canSimulateAttributeChanges");
    this.showSimulateCatProdInfoChanges = user.systemAuthorization.propertyMap.get("canSimulateCatProdInfoChanges");
    this.showSimulateJeevesProdInfoChanges = user.systemAuthorization.propertyMap.get("canSimulateJeevesProdInfoChanges");
    this.showPerformBomChanges = user.systemAuthorization.propertyMap.get("canPerformBOMChanges");
    this.showPerformPriceChanges = user.systemAuthorization.propertyMap.get("canPerformPriceChanges");
    this.showPerformCompStringChanges = user.systemAuthorization.propertyMap.get("canPerformCompStringChanges");
    this.showPerformAttributeChanges = user.systemAuthorization.propertyMap.get("canPerformAttributeChanges");
    this.showPerformCatProdInfoChanges = user.systemAuthorization.propertyMap.get("canPerformCatProdInfoChanges");
    this.showPerformJeevesProdInfoChanges = user.systemAuthorization.propertyMap.get("canPerformJeevesProdInfoChanges");
    // End customization

    // TODO authorization
    this.showAdminSection = user.systemAuthorization.canReloadCache;
  }

  ngOnDestroy() {
    this.appStoreSubscriptionManager.dispose();
    super.ngOnDestroy();
  }

  onHttpLifeCycleUpdate(http: IHttpDataInfo) {
    if (this.enableDefaultLifeCycleUpdate)
      super.onHttpLifeCycleUpdate(http);
  }
}